// extracted by mini-css-extract-plugin
module.exports = {"container":"Slide1_container__1gn1J"};